// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  ADD_MODULATION_DETAILS,
  ASSIGN_ENTITY_DETAILS,
  REMOVE_MODULATION_FROM_STATE,
  RESET_TO_INITIAL_STATE,
  UPDATE_STORED_MODULATION_DETAILS,
} from './types'

export const addModulationDetails = modulationDetails => ({
  type: ADD_MODULATION_DETAILS,
  modulationDetails,
})

export const assignEntityDetails = details => ({
  type: ASSIGN_ENTITY_DETAILS,
  details,
})

export const removeModulationFromState = modIndex => ({
  type: REMOVE_MODULATION_FROM_STATE,
  modIndex,
})

export const resetToInitialState = () => ({
  type: RESET_TO_INITIAL_STATE,
})

export const updateStoredModulationDetails = modulationDetails => ({
  type: UPDATE_STORED_MODULATION_DETAILS,
  modulationDetails,
})
